import React, { useRef, useState } from "react";
import {
  Box,
  Typography,
  Button,
  TextField,
  Select,
  MenuItem,
  DialogContent,
  Dialog,
  DialogTitle,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { ja } from "date-fns/locale";
import { useAllList } from "../hooks/logic/useAllList";
import { isNotGeneralUser } from "../constants/roles";
import { PendingReceiptStyle as styles } from "./PendingReceiptStyle";
import SearchByGenre from "../components/SearchByGenre";
import UserFilterSelect from "../components/UserFilter";
import StatusSelect from "../components/StatusSelect";
import PendingReceiptTable, {
  AllListItem,
} from "../components/allList/AllListTable";
import ProductInfoDialog from "../components/ProductInfoDialog";
import { useRecoilValue } from "recoil";
import { statusListSelector } from "../recoil/selectors/statusListSelector";
import ConfirmDialog from "../components/ConfirmDialog";

const AllList = () => {
  const {
    inputRef,
    loginUser,
    inputValue,
    handleInputChange,
    allList,
    userOptions,
    selectedUserId,
    handleUserChange,
    checkedIds,
    handleCheckChange,
    totalExpectedCount,
    searchGenres,
    selectedGenreId,
    setSelectedGenreId,
    focusInputField,
    handleGenreChange,
    searchKeyword,
    setSearchKeyword,
    searchItems,
    resetFilter,
    resetGenreWord,
    handleKeywordChange,
    expectedCount,
    handleChangeExpectedCount,
    handleRowClick,
    selectedStatusId,
    handleStatusChange,
    handleClickOkButton,
    handleUpdateOnly,
    detailDialogOpen,
    setDetailDialogOpen,
    selectedParent,
    setSelectedParent,
    selectedChildren,
    notionConfirmDialog,
    setNotionConfirmDialog,
    printConfirmDialog,
    setPrintConfirmDialog,
    handleExpiryDatePrintAllAtOnce,
    handlePrintAllAtOnce,
    handlePageChange,
    totalListCount,
    changeSortKey,
  } = useAllList();

  const [selectedDate, setSelectedDate] = useState<Date | null>(null);
  const statusList = useRecoilValue(statusListSelector);

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ja}>
      <ProductInfoDialog
        open={detailDialogOpen}
        onClose={() => {
          setSelectedParent(null);
          selectedChildren.current = [];
          setDetailDialogOpen(false);
        }}
        title="商品情報"
        parentItem={selectedParent!}
        childItems={selectedChildren.current}
        statusId={selectedParent?.statusId ?? 0}
      />
      <ConfirmDialog
        open={notionConfirmDialog}
        title="確認"
        message="予定総数と入荷総数が異なります。"
        buttons={[
          {
            label: "戻る",
            variant: "outlined",
            onClick: () => setNotionConfirmDialog(false),
          },
          {
            label: "OK",
            variant: "contained",
            onClick: () => {
              setNotionConfirmDialog(false);
              // setPrintConfirmDialog(true);
            },
          },
        ]}
      />
      <ConfirmDialog
        open={printConfirmDialog}
        title="確認"
        message="ステータス更新時にラベル印刷しますか？"
        buttons={[
          {
            label: "キャンセル",
            variant: "outlined",
            onClick: () => setPrintConfirmDialog(false),
          },
          {
            label: "更新のみ",
            variant: "contained",
            onClick: handleUpdateOnly,
          },
          {
            label: "印刷する",
            variant: "contained",
            onClick: handleUpdateOnly,
          },
        ]}
      />
      <Box sx={styles.titleBar}>
        <Typography variant="h6" sx={styles.titleText}>
          一覧
        </Typography>
      </Box>
      <Box py={0} px={0}>
        {/* 1段目 フィルター群 */}
        <Box
          display="flex"
          gap={2}
          mb={2}
          px={1}
          flexWrap="wrap"
          alignItems="center"
        >
          {isNotGeneralUser(loginUser?.permissionId) && (
            <UserFilterSelect
              options={userOptions}
              onSelect={handleUserChange}
              value={selectedUserId}
              sx={{ width: "300px" }}
            />
          )}
          <Button
            variant="outlined"
            onClick={async () => {
              await resetFilter();
              // searchItems("");
            }}
          >
            フィルター解除
          </Button>
        </Box>

        {/* 2段目 検索フィルター */}
        <Box display="flex" gap={2} mb={2} px={1} flexWrap="wrap">
          <SearchByGenre
            options={["JAN", "ASIN", "商品名", "FNSKU", "SKU"]}
            defaultGenre="JAN"
            onGenreChange={handleGenreChange}
            searchKeyword={searchKeyword}
            onKeywordChange={setSearchKeyword}
            autoFocus={true}
            onEnter={focusInputField}
          />

          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              searchItems(searchKeyword);
            }}
          >
            検索
          </Button>
        </Box>

        {/* 3段目 商品一覧テーブル */}
        <Box mt={2}>
          <PendingReceiptTable
            data={allList}
            totalListCount={totalListCount}
            checkedIds={checkedIds}
            onCheckedChange={handleCheckChange}
            onParentRowClick={handleRowClick}
            handleExpiryDatePrintAllAtOnce={handleExpiryDatePrintAllAtOnce}
            handlePrintAllAtOnce={handlePrintAllAtOnce}
            onPageChange={handlePageChange}
            onSortChange={(key, ord) => {
              changeSortKey(key, ord);
            }}
          ></PendingReceiptTable>
        </Box>
      </Box>
    </LocalizationProvider>
  );
};

export default AllList;
